export default __webpack_public_path__ + "6bcd33d117362f0a0e6b85dac769b6b0.svg";